import React from 'react';
import { UniversalCalculator } from './UniversalCalculator';
import { retirementUniversalConfig } from './universalCalculatorConfigs';

export const RetirementCalculator: React.FC = () => {
  return <UniversalCalculator config={retirementUniversalConfig} />;
};
